import { PageContextBar } from '../navigation/PageContextBar'
import './PageShell.css'

/**
 * Ensartet side-wrapper: brødkrummer, titel og indhold.
 */
export function PageShell({
  className = '',
  breadcrumbs = [],
  backTo = '/',
  backLabel = 'Hjem',
  actions = [],
  title,
  intro,
  children,
  showContext = true,
}) {
  return (
    <div className={`page-shell ${className}`.trim()}>
      {showContext && (breadcrumbs.length > 0 || backTo) && (
        <PageContextBar
          backTo={backTo}
          backLabel={backLabel}
          breadcrumbs={breadcrumbs}
          actions={actions}
        />
      )}
      {title && (
        <header className="page-header">
          <h1>{title}</h1>
          {intro && <p className="page-intro">{intro}</p>}
        </header>
      )}
      {children}
    </div>
  )
}
